import { DOC_TYPE } from 'definitions/DocType';
import { IfDlCenterFile } from 'pages/dlcenter/dlcenter-model';
import { dateutil } from 'util/dateutil';

export type SmallYn = 'y' | 'n';

// export interface IfSrchV3ReqRaw {
//   query?: string;
//   page: number;
//   totalsize: number;
//   indexsize: number;
//   index?: string;
//   sfield?: string; // 검색필드 (콤마로 필드 구분)
//   sort?: string; // 정렬필드 및 정렬방향을 설정한다 필드명/소팅방향.
//   filter?: string;
//   range?: string;
//   daterange?: string;
//   isDebug?: SmallYn;
//   pretty?: SmallYn;
// }

type SORT = 'ASC' | 'DESC' | 'SCORE';
type SORT_FIELD = '' | 'update_time' | 'doc_title.sort' | 'click_count';

type SortInfo = {
  field: SORT_FIELD;
  sort: SORT;
};

type FilterInfo = {
  docType: DOC_TYPE[]; // or
  displayTarget?: number[]; // gte.
  exposeSiteLanguage?: string;
  categoryId?: number[]; // or
  tag?: string[]; // and
  finished?: boolean;
  lsRelated?: boolean;
  fileType?: string; // File. file_type
  targetSoftwareType?: string; // File. target_software_type
};

type DateRangeInfo = {
  start?: Date;
  end?: Date;
};

type RangeInfo = {
  field: 'display_target' | 'doc_point' | 'answer_cnt' | 'bad_count' | 'good_count' | 'click_count';
  start?: number;
  startOp: 'gte' | 'gt';
  end?: number;
  endOp: 'lte' | 'lt';
};

type IndexType = 'TOTAL' | 'all' | 'download' | 'knowledge' | 'sample' | 'qna' | 'colorful' | 'news_event';

export class SrchV3Req {
  query?: string;
  page: number;
  totalsize: number = 5;
  indexsize: number = 10;
  index?: IndexType = 'all'; // 기본 all 을 사용하도록 처리함.
  sfield?: string; // 검색필드 (콤마로 필드 구분)
  sort?: SortInfo; // 정렬필드 및 정렬방향을 설정한다 필드명/소팅방향.
  filter?: FilterInfo;
  range?: RangeInfo;
  daterange?: DateRangeInfo;
  isDebug?: SmallYn;
  pretty?: SmallYn;
}

export class SrchV3ReqBff {
  query?: string;
  page: number;
  totalsize: number = 5;
  indexsize: number = 10;
  index?: IndexType = 'all'; // 기본 all 을 사용하도록 처리함.
  sfield?: string; // 검색필드 (콤마로 필드 구분)
  sort?: string; // 정렬필드 및 정렬방향을 설정한다 필드명/소팅방향.
  //filter?: FilterInfo;
  docType?: DOC_TYPE[]; // or
  displayTarget?: number[]; // gte.
  exposeSiteLanguage?: string;
  categoryId?: number[]; // or
  tag?: string[]; // and
  range?: string;
  daterange?: string;
  isDebug?: SmallYn;
  pretty?: SmallYn;
  fileType?: string; // File. file_type
  targetSoftwareType?: string; // File. target_software_type
  lsRelated?: boolean;
}

export interface IfSrchV3Req extends SrchV3Req {}

const getStartDate = (date?: Date): string => {
  if (!date) return '0000-00-00';
  return dateutil.toYyyyMDDash(date);
};
const getEndDate = (date?: Date): string => {
  if (!date) return '9999-12-31';
  return dateutil.toYyyyMDDash(date);
};

const getDateRange = (daterange: DateRangeInfo): string => {
  if (!daterange) return undefined;
  return `${getStartDate(daterange.start)},${getEndDate(daterange.end)}`;
};

const getSort = (sort: SortInfo): string => {
  if (!sort) return '';
  if (sort.sort === 'SCORE') return 'SCORE';
  return `${sort.field}/${sort.sort}`;
};

const getRange = (range: RangeInfo): string => {
  if (!range) return undefined;
  return `${range.field},${range.startOp},${range.start},${range.endOp},${range.end}`;
};

// export const getSrchV3ReqRaw = (req: IfSrchV3Req): IfSrchV3ReqRaw => {
//   const getFilter = (filter: FilterInfo): string => {
//     if (!filter) return undefined;
//     const filters = [];
//     if (filter.exposeSiteLanguage) filters.push(`expose_site_language:${filter.exposeSiteLanguage}`);
//     if (filter.docType && filter.docType.length > 0) {
//       filters.push(`(${filter.docType.map((docType) => `doc_type:${docType}`).join(' OR ')})`);
//     }
//     // if (filter.displayTarget) {
//     //   const target = filter.displayTarget;
//     //   const targets = target >= 20 ? [20] : target >= 15 ? [15, 20] : target >= 10 ? [10, 15, 20] : [0, 10, 15, 20];
//     //   filters.push(`(${targets.map((target) => `display_target:${target}`).join(' OR ')})`);
//     // }
//     if (filter.displayTarget && filter.displayTarget.length > 0) {
//       const targets = filter.displayTarget;
//       filters.push(`(${targets.map((target) => `display_target:${target}`).join(' OR ')})`);
//     }
//     if (filter.categoryId && filter.categoryId.length > 0)
//       filters.push(`(${filter.categoryId.map((categoryId) => `category_id:${categoryId}`).join(' OR ')})`);
//     if (filter.tag && filter.tag.length > 0) filters.push(`(${filter.tag.map((tag) => `tag:${tag}`).join(' AND ')})`); // 태그는 AND로 검색.
//     return filters.length > 0 ? `(${filters.join(' AND ')})` : undefined;
//   };

//   return {
//     ...req,
//     sort: getSort(req.sort),
//     page: req.page,
//     filter: getFilter(req.filter),
//     daterange: getDateRange(req.daterange),
//     range: getRange(req.range),
//     totalsize: req.totalsize,
//     indexsize: req.indexsize,
//   };
// };

export const getSrchV3ReqBffRaw = (req: IfSrchV3Req): SrchV3ReqBff => {
  const { filter, ...rest } = req;
  return {
    ...rest,
    sort: getSort(req.sort),
    page: req.page,
    daterange: getDateRange(req.daterange),
    range: getRange(req.range),
    totalsize: req.totalsize,
    indexsize: req.indexsize,
    ...filter,
  };
};

/*

{
  "isOk": true,
  "returnMsg": "",
  "query": "",
  "index": "all",
  "pageNo": 1,
  "totalCount": 3617,
  "result": [
    {
      "indexName": "all",
      "indexGetCount": 1,
      "indexTotalCount": 3617,
      "items": [
{
    "id": "25839",
    "@timestamp": "20260708045415",
    "admission": "APPROVED",
    "answer_cnt": "0",
    "bad_count": "0",
    "blob_url_for_large_file": "^^^^",
    "category_id": "2",
    "click_count": "6",
    "description": " 본문 입력aaa",
    "discontinue": "false",
    "display_target": "0",
    "doc_point": "6",
    "doc_sample_smry": "",
    "doc_title": "자료 > 사용 설명서 - 첨부파일 버전관리 테스트",
    "doc_type": "MANUAL",
    "employ": "",
    "expose": "true",
    "expose_site_language": "ko-KR",
    "file_id": "71774^^71775^^71776",
    "file_key": "document/17719312901950^^document/17719310551020^^document/17719308665740",
    "file_lang": "KO^^KO^^KO",
    "file_name": "test-image.png^^test-excel.xlsx^^test-image.png",
    "file_size": "22^^263^^22",
    "file_type": "^^^^",
    "file_version": "1.0.2^^1.0.1^^1.0.0",
    "file_version_id": "59489^^59490^^59491",
    "finished": "false",
    "good_count": "0",
    "image_url": "",
    "last_modifier_id": "myleed@ls-electric.com",
    "ls_related": "true",
    "parent_id": "",
    "product": "저압 드라이브",
    "qrtr_doc_point": "",
    "question_id": "",
    "related_products": "",
    "search_expose": "true",
    "tag": "저압 드라이브",
    "target_software_type": "^^^^",
    "update_time": "2026-07-07 06:20:45",
    "user_bad_cnt": "0",
    "user_good_cnt": "0",
    "writer_id": "Unknown",
    "writer_nickname": "Unknown"
}
      ]
    }
  ]
} 
*/

export interface IfSrchV3File {
  id?: number;
  key?: string;
  lang?: string;
  name?: string;
  size?: number;
  type?: string;
  version?: string;
  version_id?: number;
  target_software_type?: string;
}

export interface IfSrchV3Item {
  id?: number;
  admission?: string;
  answer_cnt?: number;
  bad_count?: number;
  category?: string;
  category_id?: string;
  click_count?: number;
  description?: string;
  discontinue?: boolean;
  display_target?: number;
  doc_point?: number;
  doc_sample_smry?: string;
  doc_title?: string;
  doc_type?: string;
  employ?: boolean;
  expose?: boolean;
  expose_site_language?: string;
  finished?: boolean;
  good_count?: number;
  image_url?: string;
  last_modifier_id?: string;
  ls_related?: boolean;
  parent_id?: number;
  product?: string;
  qrtr_doc_point?: number;
  question_id?: number;
  related_products?: string;
  search_expose?: boolean;
  tag?: string[];
  update_time?: Date;
  user_bad_cnt?: number;
  user_good_cnt?: number;
  writer_id?: string;
  writer_nickname?: string;
  sample_version?: string;

  files?: IfSrchV3File[];
}

// 추가. fetchAdditionalData true 일때만 사용. DlCenter에서는 무조건 사용함.
export interface IfSrchV3ItemAddt extends IfSrchV3Item {
  discontinue?: boolean;
  dlfiles?: IfDlCenterFile[]; // SQL 로 조회된 파일 목록.
}

export interface IfSrchV3ItemRaw {
  id?: string;
  admission?: string;
  answer_cnt?: string;
  bad_count?: string;
  category?: string;
  category_id?: string;
  click_count?: string;
  discontinue?: string;
  description?: string;
  display_target?: string;
  doc_point?: string;
  doc_sample_smry?: string;
  doc_title?: string;
  doc_type?: string;
  employ?: string;
  expose?: string;
  expose_site_language?: string;
  file_id?: string; // "^^" 로 구분된 파일 ID 목록.
  file_key?: string; // "^^" 로 구분된 파일 Key 목록.
  file_lang?: string; // "^^" 로 구분된 파일 언어 목록.
  file_name?: string; // "^^" 로 구분된 파일 이름 목록.
  file_size?: string; // "^^" 로 구분된 파일 크기 목록.
  file_type?: string; // "^^" 로 구분된 파일 타입 목록.
  file_version?: string; // "^^" 로 구분된 파일 버전 목록.
  file_version_id?: string; // "^^" 로 구분된 파일 버전 ID 목록.
  target_software_type?: string; // "^^" 로 구분된 타겟 소프트웨어 타입 목록.
  blob_url_for_large_file?: string; // "^^" 로 구분된 대형 파일 URL 목록.
  finished?: string;
  good_count?: string;
  image_url?: string;
  last_modifier_id?: string;
  ls_related?: string;
  parent_id?: string;
  product?: string;
  qrtr_doc_point?: string;
  question_id?: string;
  related_products?: string;
  search_expose?: string;
  tag?: string;
  update_time?: string;
  user_bad_cnt?: string;
  user_good_cnt?: string;
  writer_id?: string;
  writer_nickname?: string;
  sample_version?: string;
}

export interface IfSrchV3IndexRes {
  indexName: string;
  indexGetCount: number;
  indexTotalCount: number;
  items: IfSrchV3Item[];
}

export interface IfSrchV3Res {
  isOk: boolean;
  returnMsg: string;
  query: string;
  index: string;
  pageNo: number;
  totalCount: number;
  result: IfSrchV3IndexRes[];
}

const zip = (...arrays) =>
  Array.from({ length: Math.max(...arrays.map((a) => a.length)) }, (_, i) => arrays.map((a) => a[i]));

const getFiles = (item: IfSrchV3ItemRaw): IfSrchV3File[] => {
  if (!item.file_id) return [];
  return zip(
    item.file_id.split('^^'),
    item.file_key.split('^^'),
    item.file_lang.split('^^'),
    item.file_name.split('^^'),
    item.file_size.split('^^'),
    item.file_type.split('^^'),
    item.file_version.split('^^'),
    item.file_version_id.split('^^'),
    item.target_software_type.split('^^'),
    item.blob_url_for_large_file.split('^^')
  )
    .map(([id, key, lang, name, size, type, version, version_id, target_software_type, blob_url_for_large_file]) => ({
      id: Number(id),
      key,
      lang,
      name,
      size: Number(size),
      type,
      version,
      version_id: Number(version_id),
      target_software_type,
      blob_url_for_large_file,
    }))
    .filter((e) => !!e.id); // id 가 없는 경우 제외.
};

export const fixSrchV3Item = (item: IfSrchV3ItemRaw): IfSrchV3Item => {
  const getBoolean = (value: string) => {
    if (value === 'true') return true;
    if (value === 'false') return false;
    return undefined;
  };
  const getNumber = (value: string) => {
    if (value === '') return undefined;
    return Number(value);
  };

  const getDate = (value: string) => {
    if (value === '') return undefined;
    return new Date(value);
  };

  return {
    ...item,
    answer_cnt: getNumber(item.answer_cnt),
    good_count: getNumber(item.good_count),
    bad_count: getNumber(item.bad_count),
    click_count: getNumber(item.click_count),
    discontinue: getBoolean(item.discontinue),
    doc_point: getNumber(item.doc_point),
    qrtr_doc_point: getNumber(item.qrtr_doc_point),
    question_id: getNumber(item.question_id),
    user_bad_cnt: getNumber(item.user_bad_cnt),
    user_good_cnt: getNumber(item.user_good_cnt),
    expose: getBoolean(item.expose),
    employ: getBoolean(item.employ),
    finished: getBoolean(item.finished),
    ls_related: getBoolean(item.ls_related),
    search_expose: getBoolean(item.search_expose),
    update_time: getDate(item.update_time),
    parent_id: getNumber(item.parent_id),
    display_target: getNumber(item.display_target),
    id: getNumber(item.id),
    tag: item.tag ? item.tag.split('^^').filter(Boolean) : [],
    files: getFiles(item),
  };
};
